const categories = [
  {
    title: "Restaurants",
    description:
      "Trouvez le restaurant parfait et profitez de chaque deal pour régaler vos papilles et votre porte monnaie.",
    src: "/Carousel/restaurantImg.jpg",
    to : "/restaurants",
  },
  {
    title: "Activités",
    description:
      "Sensation fortes, moments fun et sorties. Trouvez l’activité qui vous fait vibrer à prix réduit.",
    src: "/Carousel/activityImg.jpg",
    to : "/activities",
  },
  {
    title: "Bien-être & Spa",
    description:
      "Oﬀrez-vous un moment pour prendre soin de vous. Massage, spa, soin du visage… grâce à nos oﬀres la détente devient enfin accessible.",
    src: "/Carousel/beautyImg.jpg",
    to : "/beauty",
  },
  {
    title: "Epiceries",
    description:
      "Faites le plein de saveurs pour vos repas, sans exploser votre budget.",
    src: "/Carousel/alimentationImg.jpg",
    to : "/alimentation",
  },
  {
    title: "Services auto",
    description:
      "Prenez soin de vos véhicules sans vous ruiner ! Profitez de nos oﬀres exclusives pour votre entretien auto.",
    src: "/Carousel/carsImg.jpg",
    to : "/cars",
  },
];

export default categories;